"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegBase = void 0;
const utils_1 = require("../utils");
/**
 * Base
 */
class AnIntegBase {
    static isLoaded() {
        return true;
    }
    static sendInit(siteCategory, userId, email, coupon) {
        return true;
    }
    static sendPage(siteCategory, userId, email) {
        return true;
    }
    static getActiveSiteCategories() {
        const pixelConfig = utils_1.FFAnalyticsUtils.isProd() ?
            this.pixelId.prod :
            this.pixelId.dev;
        const keys = Object.entries(pixelConfig)
            .filter(([k, _v]) => k !== "defaultId")
            .filter(([_k, v]) => v !== null)
            .map(([k, _v]) => k);
        if (keys.length !== 0) {
            return keys;
        }
        return [null];
    }
    static getProdPixelId(siteCategory) {
        if (siteCategory !== null) {
            if (this.pixelId.prod.hasOwnProperty(siteCategory)) {
                const ret = this.pixelId.prod[siteCategory];
                if (ret !== null) {
                    return ret;
                }
            }
            else {
                throw Error(`Invalid site category: ${siteCategory}`);
            }
        }
        if (this.pixelId.prod.defaultId === null) {
            throw new Error(`Default pixel id is null`);
        }
        return this.pixelId.prod.defaultId;
    }
    static getDevPixelId(siteCategory) {
        if (siteCategory !== null) {
            if (this.pixelId.dev.hasOwnProperty(siteCategory)) {
                const ret = this.pixelId.dev[siteCategory];
                if (ret !== null) {
                    return ret;
                }
            }
            else {
                throw Error(`Invalid site category: ${siteCategory}`);
            }
        }
        if (this.pixelId.dev.defaultId === null) {
            throw new Error(`Default pixel id is null`);
        }
        return this.pixelId.dev.defaultId;
    }
    static getPixelId(siteCategory) {
        if (!utils_1.FFAnalyticsUtils.isProd()) {
            return this.getDevPixelId(siteCategory);
        }
        return this.getProdPixelId(siteCategory);
    }
    static sendTrackClubLanding(siteCategory, coupon) {
        return true;
    }
    static sendTrackClubLandingLegacy(siteCategory, coupon) {
        return true;
    }
    static sendTrackClubLanding3(siteCategory, coupon) {
        return true;
    }
    static sendTrackClubLanding4(siteCategory, coupon) {
        return true;
    }
    static sendTrackClickCtaLanding3(siteCategory, testName, ctaName, variantName, targetUrl) {
        return true;
    }
    static sendTrackClickCtaLanding4(siteCategory, testName, ctaName, variantName, targetUrl) {
        return true;
    }
    static sendTrackQuizStyleLegacy(siteCategory, response) {
        return true;
    }
    static sendTrackQuizDayLook(siteCategory, response) {
        return true;
    }
    static sendTrackQuizNightLook(siteCategory, response) {
        return true;
    }
    static sendTrackQuizShoeStyle(siteCategory, response) {
        return true;
    }
    static sendTrackQuizExerciseFrequency(siteCategory, response) {
        return true;
    }
    static sendTrackQuizFirstSelectedPackage(siteCategory, response) {
        return true;
    }
    static sendTrackQuizTopSize(siteCategory, response) {
        return true;
    }
    static sendTrackQuizTopSizeLegacy(siteCategory, response) {
        return true;
    }
    static sendTrackQuizBottomSize(siteCategory, response) {
        return true;
    }
    static sendTrackQuizBottomSizeLegacy(siteCategory, response) {
        return true;
    }
    static sendTrackQuizBottomFit(siteCategory, response) {
        return true;
    }
    static sendTrackQuizBottomFitLegacy(siteCategory, response) {
        return true;
    }
    static sendTrackQuizShoeSize(siteCategory, response) {
        return true;
    }
    static sendTrackQuizShoeSizeLegacy(siteCategory, response) {
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory, email) {
        return true;
    }
    static sendTrackQuizStart(siteCategory) {
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        return true;
    }
    static sendTrackQuizStartLegacy(siteCategory) {
        return true;
    }
    static sendTrackQuizComplete(siteCategory) {
        return true;
    }
    static sendTrackQuizCompleteLegacy(siteCategory) {
        return true;
    }
    static sendTrackPlanSelected(siteCategory, planName) {
        return true;
    }
    static sendTrackPlanSelectedLegacy(siteCategory, planName, explicit) {
        return true;
    }
    static sendTrackAddBillingInfo(siteCategory) {
        return true;
    }
    static sendTrackAddBillingInfoLegacy(siteCategory) {
        return true;
    }
    static sendTrackAddShippingInfo(siteCategory) {
        return true;
    }
    static sendTrackAddShippingInfoLegacy(siteCategory) {
        return true;
    }
    static sendTrackClubAddPaymentInfo(siteCategory) {
        return true;
    }
    static sendTrackClubAddPaymentInfoLegacy(siteCategory) {
        return true;
    }
    static sendTrackSubmittedPaymentReviewLegacy(siteCategory) {
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        return true;
    }
    static sendTrackClubPurchase(siteCategory, userId, email, price, style, color, coupon) {
        return true;
    }
    static sendTrackClubPurchaseLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return true;
    }
    static sendTrackClubRejoinLegacy(siteCategory, userId, email, price) {
        return true;
    }
    static sendTrackEcommAccountCreate(siteCategory, userId, email) {
        return true;
    }
    static sendTrackEcommAddPaymentInfo(siteCategory) {
        return true;
    }
    static sendTrackEcommPurchase(siteCategory, userId, orderId, price, coupon) {
        return true;
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        return true;
    }
    static sendTrackEcommProductView(siteCategory, productId) {
        return true;
    }
    static sendTrackEcommProductAddToCart(siteCategory, productId) {
        return true;
    }
}
exports.AnIntegBase = AnIntegBase;
AnIntegBase.shouldSendIfNoConsent = false;
AnIntegBase.shouldSendEveryPage = false;
//
// Club Events
//
AnIntegBase.shouldSendTrackQuizStyleLegacy = false;
AnIntegBase.shouldSendTrackQuizDayLook = false;
AnIntegBase.shouldSendTrackQuizNightLook = false;
AnIntegBase.shouldSendTrackQuizShoeStyle = false;
AnIntegBase.shouldSendTrackQuizExerciseFrequency = false;
AnIntegBase.shouldSendTrackQuizFirstSelectedPackage = false;
AnIntegBase.shouldSendTrackQuizTopSize = false;
AnIntegBase.shouldSendTrackQuizTopSizeLegacy = false;
AnIntegBase.shouldSendTrackQuizBottomSize = false;
AnIntegBase.shouldSendTrackQuizBottomSizeLegacy = false;
AnIntegBase.shouldSendTrackQuizBottomFit = false;
AnIntegBase.shouldSendTrackQuizBottomFitLegacy = false;
AnIntegBase.shouldSendTrackQuizShoeSize = false;
AnIntegBase.shouldSendTrackQuizShoeSizeLegacy = false;
AnIntegBase.shouldSendTrackClubLanding = false;
AnIntegBase.shouldSendTrackClubLandingLegacy = false;
AnIntegBase.shouldSendTrackClubLanding3 = false;
AnIntegBase.shouldSendTrackClubLanding4 = false;
AnIntegBase.shouldSendTrackClickCtaLanding3 = false;
AnIntegBase.shouldSendTrackClickCtaLanding4 = false;
AnIntegBase.shouldSendTrackQuizStart = false;
AnIntegBase.shouldSendTrackQuizStartLegacy = false;
AnIntegBase.shouldSendTrackQuizComplete = false;
AnIntegBase.shouldSendTrackQuizCompleteLegacy = false;
AnIntegBase.shouldSendTrackClubCheckoutStart = false;
AnIntegBase.shouldSendTrackArriveSignupLoginLegacy = false;
AnIntegBase.shouldSendTrackClubAccountCreate = false;
AnIntegBase.shouldSendTrackClubAccountCreateLegacy = false;
AnIntegBase.shouldSendTrackPlanSelected = false;
AnIntegBase.shouldSendTrackPlanSelectedLegacy = false;
AnIntegBase.shouldSendTrackAddBillingInfo = false;
AnIntegBase.shouldSendTrackAddBillingInfoLegacy = false;
AnIntegBase.shouldSendTrackAddShippingInfo = false;
AnIntegBase.shouldSendTrackAddShippingInfoLegacy = false;
AnIntegBase.shouldSendTrackClubAddPaymentInfo = false;
AnIntegBase.shouldSendTrackClubAddPaymentInfoLegacy = false;
AnIntegBase.shouldSendTrackSubmittedPaymentReviewLegacy = false;
AnIntegBase.shouldSendTrackClubPurchase = false;
AnIntegBase.shouldSendTrackClubPurchaseLegacy = false;
AnIntegBase.shouldSendTrackClubThankyou = false;
AnIntegBase.shouldSendTrackClubThankyouLegacy = false;
AnIntegBase.shouldSendTrackClubRejoinLegacy = false;
//
// Ecomm Events
//
AnIntegBase.shouldSendTrackEcommAccountCreate = false;
AnIntegBase.shouldSendTrackEcommAddPaymentInfo = false;
AnIntegBase.shouldSendTrackEcommPurchase = false;
AnIntegBase.shouldSendTrackEcommThankyou = false;
AnIntegBase.shouldSendTrackEcommProductView = false;
AnIntegBase.shouldSendTrackEcommProductAddToCart = false;
AnIntegBase.utmSource = null;
AnIntegBase.pixelId = {
    prod: {
        defaultId: null,
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: null,
        ecomm: null,
        club: null,
    },
};
